import { hooks as commonHooks } from '@sitebuilder/common';

export interface RunningFooterProps {
    rest: {
        isRunningFooter?: boolean;
        pptxIsRunningFooter?: boolean;
    };
    data: Record<string, unknown> | undefined;
}

const RunningFooter = ({ rest, data }: RunningFooterProps) => {
    const { Placeholder, inEditMode } = commonHooks.useAppContext();
    return (
        <>
            {rest?.isRunningFooter || rest?.pptxIsRunningFooter ? (
                <div className="running-footer">
                    {inEditMode && (
                        <div className="running-footer-edit-mode">
                            <div className="border" />
                            <span>Add running footer components below this</span>
                        </div>
                    )}
                    <Placeholder
                        contentPlaceHolderId={'running-footer'}
                        parentWidgetInstanceId={'root'}
                        data={data}
                    />
                </div>
            ) : null}
        </>
    );
};

export default RunningFooter;
